(function () {
    'use strict';

    angular.module("imApp").factory("priceListBusCosService", ['$ihttp', function ($ihttp) {
        let service = {
            listBusinessCompanies: function (parms) {
                return $ihttp.post({
                    method: 666,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
